const initialiseSlider = (slider, card) => {
  const length = $(card).data('length');
  const sliderWidth = $(window).outerWidth();
  const nextArrows = slider
    .closest('.carousel-wrapper')
    .find('.carousel-slider-next-btn');
  const prevArrows = slider
    .closest('.carousel-wrapper')
    .find('.carousel-slider-prev-btn');
  const hideAtMd = length <= 2 && sliderWidth > 768;
  const hideAtLg = length <= 3 && sliderWidth > 1024;
  const hideAtXl = length === 4 && sliderWidth > 1280;

  if (length <= 1 || hideAtMd || hideAtLg || hideAtXl) {
    prevArrows.css({ visibility: 'hidden' });
    nextArrows.css({ visibility: 'hidden' });
  } else {
    prevArrows.css({ visibility: 'visible' });
    nextArrows.css({ visibility: 'visible' });
  }
};

$(() => {
  const sliders = $('.staff-component');

  sliders.each(function (idx, element) {
    const slider = $(element);
    const card = slider.find('.staff-card');
    initialiseSlider(slider, card);
    $(window).on('resize', function () {
      initialiseSlider(slider);
    });
  });
});
